<script>
    import { onDestroy } from 'svelte';
    import { fade } from 'svelte/transition';
    import Avatar from "./Avatar.svelte"
    import ChatContent from "./ChatContent.svelte"
    import ChatInput from "./ChatInput.svelte"
    import API, {API_UPLOAD} from "../../class/API";
    import {decompress_array_packet} from "./Utils";
    import ChatError from "./ChatError.svelte";
    import { t } from "../../i18n";

    // ------------------------------------------
    export let path = "";
    export let title = "";
    // ------------------------------------------

    let chatReadList = {};

    $: error = null;
    $: content = null;
    $: loading = true;

    $: filesUploading = [];

    update();

    let timer = setInterval(()=>update(), 4000);
    onDestroy(()=>clearInterval(timer));


    let onChatRead = function(id){
        chatReadList[id] = true;
    }


    let startUploadingFiles = function(files)
    {
        filesUploading=[...files.detail].map(f=>({name: f.name+"", size: 0+f.size, f}));
        let cb = 0;
        let refresh = ()=>filesUploading = filesUploading;
        for(let i in filesUploading)
        {
            let f = filesUploading[i]; if(!f)continue;
            f.status = $t('chat.connecting');

            API_UPLOAD('notes.upload', f.f, {
                progress: function(percent){
                    f.status = percent+' ...';
                    refresh();
                }

            }).then(function(){
                f.status = $t('chat.done');
                refresh();
            }).catch(function(err){
                f.status = $t('chat.error_prefix') + err;
                refresh();
            });

            cb++;
        }

    };




    // ------------------------------------------
    export function clear(){
        content = [{msg:'cleared!'}]; setTimeout(() => content = null, 1000);
    };
    export function update(){
        let read = chatReadList ? Object.keys(chatReadList) : [];
        chatReadList = {};
        API('notes.get', {path, read})
            .then(data => {if(error)error=null; content = decompress_array_packet(data)})
            .catch(err => error = err)
            .finally(() => loading = false);
    };
    export function retry(){
        error = null;
        loading = true;
        update();
    }
    export function send(msg){
        if(!msg||!msg.trim())return;
        return API('notes.post', {path, msg}).finally(update);
    }
</script>


<div class="widget-chat-card" style="height:100%;">
    <div class="widget-chat widget-chat-messages">
        <div class="card" style="margin-bottom: 0;height:100%;">
            <div class="card-header border-bottom p-0">
                <div class="media m-75">
                    <Avatar></Avatar>
                </div>
            </div>


            {#if loading}
                    <div class="card-body widget-chat-container widget-chat-scroll"><div in:fade>{$t('chat.loading')}</div></div>

            {:else if error}
                <ChatError {error} on:retry={retry}></ChatError>

            {:else}
                <ChatContent {filesUploading} {path} {content} {title} on:chatRead={e=>onChatRead(e.detail)}></ChatContent>

            {/if}

            {#if !loading && !error}
                <div class="card-footer border-top p-1">
                    <ChatInput on:send={(e)=>send(e.detail)} on:files={files => startUploadingFiles(files)} ></ChatInput>
                </div>
            {/if}

        </div>
    </div>
</div>

